import { Injectable, EventEmitter } from '@angular/core';


@Injectable()
export class DataToSaveService {

  private dataToSave: any;
  private grooveInputs: any;
  private paths: string[] = [];
  private activeSections: {
    activateDesign: boolean
    activateGroove: boolean
    activateOring: boolean
  };
  private oringInputs: any;
  private asCode: number;
  private calculatedData: any;
  private product: any;
  private measurement: number;
  private recommendationType: number;
  private grooveType: number;
  private dataForSave: any;
  private calculationData: any;
  private grooveItem: any;
  private grooveItems: any;
  private asStep2: string;
  clearedData = true;

  public fileNameEmitter = new EventEmitter<string>();

  constructor() {
  }

  setData(data) {
    this.dataToSave = data;
  }

  getData() {
    return this.dataToSave;
  }

  emitFileNameEvent(name) {
    this.fileNameEmitter.emit(name);
  }
  getFileNameEmitter() {
    return this.fileNameEmitter;
  }

  setGrooveInputs(inputs): void {
    this.grooveInputs = inputs;
  }

  getGrooveInputs() {
    return this.grooveInputs;
  }

  setPath(path): void {
    this.paths.push(path);
  }

  getPaths(): string[] {
    return this.paths;
  }

  setActiveSections(sections: any): void {
    this.activeSections = sections;
  }

  getActiveSections(){
    return this.activeSections;
  }

  setOringInputs(inputs, as: number): void {
    this.oringInputs = inputs;
    this.asCode = as;
  }

  getOringInputs() {
    return {
      oringInputs: this.oringInputs,
      asCode: this.asCode
    };
  }

  setCalculatedData(data): void {
    this.calculatedData = data;
  }

  getCalculatedData() {
    return this.calculatedData;
  }

  setProduct(product): void {
    this.product = product;
  }

  getProduct(): any {
    return this.product;
  }

  setMeasurement(unit: number): void {
    this.measurement = unit;
  }

  getMeasurement(): number {
    return this.measurement;
  }

  setRecommendationType(type: number): void {
    this.recommendationType = type;
  }

  getRecommendationType(): number {
    return this.recommendationType;
  }

  setGrooveType(type: number): void {
    this.grooveType = type;
  }

  getGrooveType(): number {
    return this.grooveType;
  }

  setDataToSave(data): void {
    this.dataForSave = data;
  }

  setCalculationData(data): void {
    this.calculationData = data;
  }

  getSavedData(): any {
    return this.dataForSave;
  }

  getCalculationData(): any {
    return this.calculationData;
  }

  clearData(): void {
    this.paths = [];
  }

  setGrooveItem(item: any): void {
    this.grooveItem = item;
  }

  getGrooveItem(): any {
    return this.grooveItem;
  }

  setGrooveItems(items: any): void {
    this.grooveItems = items;
  }

  getGrooveItems(): any {
    return this.grooveItems;
  }

  setAsCode(asCode: string): void {
    this.asStep2 = asCode;
  }

  getAsCode(): any {
    return this.asStep2;
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/service/data-to-save.service.ts